import { useLayoutEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { GROCERY_LIST_DRAFT_KEPT } from '../../redux/actions/calendar';
import { mergeGroceryListDraft } from '../../redux/food/groceryListDraft';
import { selectActiveList, selectActiveListRows } from '../../redux/food/selectors';

/**
 * The active list's draft (food/groceryListDraft.js) at `minute`, merged with the food store's rows
 * whenever they change, or null while the store has no active list. A new draft is kept in the
 * calendar's state once rendered, so the reorder and the next render find the same one.
 */
export default function useGroceryListDraft(minute) {
	const dispatch = useDispatch();
	const list = useSelector((state) => selectActiveList(state.food.entities));
	const rows = useSelector((state) => selectActiveListRows(state.food.entities, minute));
	const lastBoughtByName = useSelector((state) => state.food.entities.lastBoughtByName);
	const held = useSelector((state) => state.calendar.groceryListDraft);
	const saving = useSelector((state) => !!held && state.calendar.savingGroceryListItems.has(held));
	// Changed in place (a reorder, a save's answer): only a re-render shows it.
	useSelector((state) => state.calendar.groceryListDraftVersion);

	const draft = useMemo(
		() => mergeGroceryListDraft(held, list, rows, lastBoughtByName, { keepOrder: saving }),
		[held, list, rows, lastBoughtByName, saving]
	);
	useLayoutEffect(() => {
		if(draft !== held) {
			dispatch({ type: GROCERY_LIST_DRAFT_KEPT, payload: draft });
		}
	}, [draft, held]);
	return draft;
}
